import { useMutation, useQueryClient } from '@tanstack/react-query'
import { showNotification } from '@mantine/notifications'
import type { OrpcClient } from '@/orpc/client'
import { logError } from '@/utils/errorUtils'
import { useOrpc } from './useClient'

export type BatchRemoveOrgMembersInput = Parameters<OrpcClient['batchRemoveOrgMembers']>[0]

export function useBatchRemoveOrgMembers() {
  const orpc = useOrpc()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.batchRemoveOrgMembers.mutationOptions({
      onSuccess: () => {
        void queryClient.invalidateQueries({ queryKey: orpc.listPractitioners.key() })
      },
      onError: (error) => {
        logError('super', 'Failed to remove organization members', error)
        showNotification({
          color: 'red',
          title: 'Removal failed',
          message: error instanceof Error ? error.message : 'Unknown error',
        })
      },
    }),
  )
}
